define('app/views/grid_resizers_view',['app/setup'], function (takhfifan) {
  takhfifan.gridResizersView = Backbone.View.extend({

    initialize: function () {
      this.resizeGrid();
      $(window.window).resize(this.resizeGrid);
    },

    resizeGrid: function () {
      var tile = $('.yadisa-categories').find(".col1")[0];
      var width = tile.getBoundingClientRect().width;
      var rows = $('.yadisa-categories').find(".tiles-row");
      for (var i = 0; i < rows.length; ++i) {
        var item = rows[i];
        item.style.height = width + "px";
        item.style.marginBottom = (item.getBoundingClientRect().width / 200.0) + "px";
      }
    },

    remove: function () {
      $(window.window).off("resize", this.resizeGrid);
      Backbone.View.prototype.remove.apply(this, arguments);
    }
  });
});

